import { useEffect, useState } from 'react';

export const useSyncState = <T>(syncedValue: T, enabledSync = false) => {
    const [value, setValue] = useState<T>(syncedValue);

    useEffect(() => {
        if (!enabledSync) {
            return;
        }

        setValue(syncedValue);
    }, [enabledSync, syncedValue]);

    return [value, setValue] as const;
};
